import { render, staticRenderFns } from "./CheckInFooterStart.vue?vue&type=template&id=072c5363&"
import script from "./CheckInFooterStart.vue?vue&type=script&lang=js&"
export * from "./CheckInFooterStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports